import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import CreateEventReservation from './containers/CreateEventReservation';
import EditEventReservation from './containers/EditEventReservation';
import ListEventReservations from './containers/ListEventReservations';
import ViewEventReservation from './containers/ViewEventReservation';

const routes = [
    {
        type: 'crud',
        list: ListEventReservations,
        create: CreateEventReservation,
        edit: EditEventReservation,
        view: ViewEventReservation
    }
]

export default ModuleBootstrapper.getRoutes("event-reservations", routes)
